// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MGBVHMvOK1TD8j .board-canvas:last-child,
.MGBVHMvOK1TD8j .plugin-board-bar {
  transition: margin 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .MGBVHMvOK1TD8j .board-canvas:last-child,
  .MGBVHMvOK1TD8j .plugin-board-bar {
    transition: unset;
  }
}
.VUCQTkTFhnMvym .board-canvas:last-child,
.VUCQTkTFhnMvym .plugin-board-bar {
  margin-bottom: 62px;
}
.VUCQTkTFhnMvym .board-canvas:has(#board) {
  margin-bottom: var(--ds-space-0, 0);
}
.mbL3M7zH1awPW1 .board-canvas:last-child,
.mbL3M7zH1awPW1 .plugin-board-bar {
  margin-bottom: 26px;
}
.Xpq6bBra11ICMi .board-canvas:last-child,
.Xpq6bBra11ICMi .plugin-board-bar {
  margin-bottom: 26px;
}
.Xpq6bBra11ICMi .board-canvas:has(#board) {
  margin-bottom: var(--ds-space-0, 0);
}
.Xpq6bBra11ICMi.ivZ_wF4VZB8iYB .board-canvas:last-child,
.Xpq6bBra11ICMi.ivZ_wF4VZB8iYB .plugin-board-bar {
  margin-bottom: 62px;
}
`, ""]);
// Exports
export var animate = `MGBVHMvOK1TD8j`;
export var boardPanelPadding = `VUCQTkTFhnMvym`;
export var multiplePanelPadding = `mbL3M7zH1awPW1`;
export var islandOverlap = `Xpq6bBra11ICMi`;
export var singlePanel = `ivZ_wF4VZB8iYB`;
export default ___CSS_LOADER_EXPORT___;
